import { ICreateFavoriteList } from './dto/ICreateFavoriteList';
import { requests } from '../../../utils';
import { BASE_URL, BRAND_GLOBAL_DISCOVERY } from '../../../utils/endpoints';
import { IFavoriteList } from './dto/IFavoriteList';
import { BaseModel } from '../../../model/shared/BaseModel';
import { IAssignInfluencerToList } from './dto/IAssignInfluencerToList';
import { SaveCurrentGlobalFilter } from './dto/SaveGlobalFilter';
import { IInitialGlobalDiscoveryFilter } from './dto/IInitialGlobalDiscoveryFilter';
import { IListOfListsFilterParams } from './dto/IListOfListsFilterParams';
import { IAssignInfluencerToListResponse } from './dto/IAssignInfluencerToListResponse';
import { IDiscoveryPreSetData } from '../campaign/discovery/dto/IDiscoveryFilter';
import { ICollaboration } from '../../../model/shared/ICollaboration';
import { IStripeSessionResponse, StripePackage, Subscription } from '../../../model/shared/Subscription';

export const GlobalDiscoveryService = {
    getLists: (filterParams: IListOfListsFilterParams, queryParams?: string): Promise<BaseModel<IFavoriteList[]>> =>
        requests.get(`${BRAND_GLOBAL_DISCOVERY}/list?${queryParams}`, filterParams),
    createList: (body: ICreateFavoriteList) => requests.post(`${BRAND_GLOBAL_DISCOVERY}/list`, body),
    editList: (body: ICreateFavoriteList, id: number) => requests.put(`${BRAND_GLOBAL_DISCOVERY}/list/${id}`, body),
    deleteList: (id?: number) => requests.delete(`${BRAND_GLOBAL_DISCOVERY}/list/${id}`),
    duplicateList: (id?: number, body?: any) => requests.put(`${BRAND_GLOBAL_DISCOVERY}/duplicate/${id}`, body),
    assignInfluencerToList: (body: IAssignInfluencerToList): Promise<IAssignInfluencerToListResponse> =>
        requests.post(`${BRAND_GLOBAL_DISCOVERY}/list/influencer`, body),
    saveCurrentFilter: (body: SaveCurrentGlobalFilter) =>
        requests.post(`${BRAND_GLOBAL_DISCOVERY}/save/current/filters`, body),
    getInitialData: (): Promise<IInitialGlobalDiscoveryFilter> =>
        requests.get(`${BRAND_GLOBAL_DISCOVERY}/initial/data`),
    getPresetFilterData: (
        filterParams: {
            perPage: number;
            page: number;
        },
        queryParams: string
    ): Promise<BaseModel<IDiscoveryPreSetData[]>> =>
        requests.get(`${BASE_URL}admin/discovery/filter/presets?${queryParams}`, filterParams),
    getCollaborationDropdown: (filters?: { username: string }): Promise<BaseModel<ICollaboration[]>> =>
        requests.get(`${BRAND_GLOBAL_DISCOVERY}/collaboration/dropdown`, filters),
    getStripePackages: (): Promise<BaseModel<StripePackage[]>> => requests.get(`${BASE_URL}stripe/packages`),
    stripeCreateSession: (priceId: string): Promise<IStripeSessionResponse> =>
        requests.post(`${BASE_URL}stripe/create/checkout-session`, { priceId }),
    cancelSubscription: () => requests.post(`${BASE_URL}stripe/create/portal-session`, {}),
    switchToPaidSubscription: (): Promise<Subscription> => requests.post(`${BASE_URL}stripe/end/trial`, {}),
};
